import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useSearchParams } from 'react-router-dom';
import { SiteRenderer } from '../components/website/SiteRenderer';

// Staff-only draft preview of the company website (not public). ?company=<id> lets Super Admin preview any company.
export default function WebsitePreview() {
  const [params, setParams] = useSearchParams();
  const cid = params.get('company');
  const page = params.get('page') || 'home';
  const [data, setData] = useState(null);
  const [err, setErr] = useState('');
  useEffect(() => {
    axios.get(cid ? `/superadmin/companies/${cid}/website` : '/company/website').then((r) => setData(r.data)).catch((e) => setErr(e.response?.data?.detail || 'Could not load draft'));
  }, [cid]);
  if (err) return <div style={{ padding: 40, color: '#fff', background: '#0A0A0A', minHeight: '100vh' }} data-testid="website-preview-error">{err}</div>;
  if (!data) return null;
  if (!data.draft) return <div style={{ padding: 40, color: '#fff', background: '#0A0A0A', minHeight: '100vh' }}>No draft yet — apply a template first.</div>;
  const site = { ...data.draft, nav: Object.entries(data.draft.pages).filter(([, v]) => v.enabled !== false).map(([k, v]) => ({ slug: k, title: v.title, href: k === 'home' ? '/' : `/${k}` })) };
  const onNavigate = (href) => { const slug = href === '/' ? 'home' : href.replace(/^\//, ''); if (site.pages[slug]) { params.set('page', slug); setParams(params); window.scrollTo(0, 0); } };
  return (
    <div data-testid="website-preview">
      <div style={{ position: 'sticky', top: 0, zIndex: 60, background: '#fbbf24', color: '#111', fontSize: 12, fontWeight: 700, padding: '6px 16px', textAlign: 'center', letterSpacing: '0.08em', textTransform: 'uppercase' }} data-testid="website-preview-banner">
        Draft preview — not visible to the public until published · page: {site.pages[page] ? site.pages[page].title : 'Home'}
      </div>
      <SiteRenderer site={site} pageSlug={site.pages[page] ? page : 'home'} preview onNavigate={onNavigate} />
    </div>
  );
}
